import { render, staticRenderFns } from "./ChargeWalletView.vue?vue&type=template&id=303a4e48&scoped=true&"
import script from "./ChargeWalletView.vue?vue&type=script&lang=ts&"
export * from "./ChargeWalletView.vue?vue&type=script&lang=ts&"
import style0 from "./ChargeWalletView.vue?vue&type=style&index=0&id=303a4e48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303a4e48",
  null
  
)

export default component.exports